import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import PublisherEditor from "@/pages/publisher/PublisherEditor";

export const Route = createFileRoute("/publisher/new")({
  head: () => pageHead("Publisher \u2014 New \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: () => <PublisherEditor mode="new" />,
});
